export type SignOffTypeParam = 'single' | 'multi';
export const SignOffTypeParam: Record<Capitalize<SignOffTypeParam>, SignOffTypeParam> = {
  Single: 'single',
  Multi: 'multi',
};
